<template>
  <section>
    <div class="form-content">
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="申请单位">
            <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请部门">
            <el-input style="width:100%" size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="申请人">
            <el-input style="width:100%" size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="10">
          <el-form-item label="选择车辆">
            <el-select style="width:100%;" size="small" v-model="form.carId">
              <el-option v-for="item,i in carList" :key="item.id" :label="item.xh+'-'+item.pl+' ('+item.plateNo+')'"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="14">

          <div class="clear">
            <el-form-item label="使用时间">
              <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.startTime" style="width:170px!important;" type="datetime"
                placeholder="选择开始时间">
              </el-date-picker>
              <span>至</span>
              <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.endTime" style="width:170px!important;" type="datetime"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <!-- <el-form-item label="">
            <el-date-picker v-model="form.time" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item> -->
        </el-col>
      </div>

      <el-form-item label="驾驶人" v-if="carType=='1'&&useApplyType=='jt'">
        <div class="contact-user-list" v-if="selectLeader.length>0">
          <!-- {{ selectLeader }} -->
          <div class="user-item" v-for="user,i in selectLeader">
            <span class="name">{{user && user.name}}</span>
          </div>
        </div>
        <el-button @click="addUsers()" size="mini" type="primary">选择人员</el-button>
      </el-form-item>

      <el-form-item label="情况简述">
        <el-input type="textarea" placeholder="申请事由及目的地" :autosize="{ minRows: 5, maxRows: 8}" size="small"
          v-model="form.reason"></el-input>
      </el-form-item>

    </div>
  </section>

</template>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', 'useApplyType', 'carType'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        form: {},
        selectLeader: [],
        selectType: 0,

        userDeptId: "",
        carList: [],
      }
    },
    created() {
      this.getLists(this.useApplyType)
    },
    mounted() {
      this.form = this.formByFather
      if (this.form.driver) {
        this.selectLeader = [this.form.driver]
      }
    },
    methods: {
      // 获取车辆列表列表， useApplyType:jt zgs
      getLists(useApplyType) {
        ajax.get('/car/list', {
          depId: useApplyType == 'jt' ? 7 : this.form.depId
        }, (res) => {
          this.loading = false
          this.carList = res.vo.array
        })
      },
      // 返回form
      getFromData() {
        return this.form
      },
      // 添加驾驶员
      addUsers() {
        let _sr = this.selectLeader
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactApprovalItem', false)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)

        setTimeout(() => {
          this.selectType = 3
        }, 500)
      },
    },
    watch: {
      contactSelectArr() {
        if (this.selectType == 3) {
          this.selectLeader = this.contactSelectArr
          this.selectType = 0
        }
      },
      selectLeader() {
        this.form.driverId = this.selectLeader[0] ? this.selectLeader[0].id : ''
      },
      formByFather() {
        this.form = this.formByFather
        if (this.form.driver) {
          this.selectLeader = [this.form.driver]
        }
      },

      useApplyType() {
        this.getLists(this.useApplyType)
      },

    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/car/use.vue